import { render, staticRenderFns } from "./PaceMakerImpiantoEditComponent.vue?vue&type=template&id=05b822ee&scoped=true"
import script from "./PaceMakerImpiantoEditComponent.vue?vue&type=script&lang=js"
export * from "./PaceMakerImpiantoEditComponent.vue?vue&type=script&lang=js"
import style0 from "./PaceMakerImpiantoEditComponent.vue?vue&type=style&index=0&id=05b822ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b822ee",
  null
  
)

export default component.exports